import React, { useContext } from "react";
import { BlockPageProps } from "./BlockPage.props";
import "./BlockPage.styles.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { GlobalContext } from "../../../context/GlobalState";

export const BlockPage: React.FC<BlockPageProps> = ({ open = false }) => {
  const { globalState } = useContext(GlobalContext);

  const isOpen = globalState.appReadyState === "pending";

  return (
      <Backdrop
          id="block-loading-page"
          sx={{ color: "#fff" }}
          transitionDuration={0}
          open={open}
      >
        <CircularProgress />
      </Backdrop>
  );
};